export default ({ request }) => ({
  scmInfoListApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/list',
      method: 'post',
      data,
    })
  },
  scmInfoDetailApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/detail',
      method: 'post',
      data,
    })
  },
  scmInfoFollowApi(data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/follow',
      method: 'post',
      data
    })
  },
  scmInfoSaveApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/save',
      method: 'post',
      data,
    })
  },
  // 转正申请
  scmInfoAppleApi(data = {}) {
    return request({
      url: '/oa/scm/info/regularApply',
      method: 'post',
      data,
    })
  },
  scmInfoUpdateStatusApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/updateStatus',
      method: 'post',
      data,
    })
  },
  myScmInfoListApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/myList',
      method: 'post',
      data,
    })
  },
  getMySupplierTotalApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/getMySupplierTotal',
      method: 'post',
      data,
    })
  },
  scmInfoAuditApi(data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/audit',
      method: 'post',
      data,
    })
  },
  scmInfoApplyApi(data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/apply',
      method: 'post',
      data,
    })
  },
  scmInfoRollbackApplyApi(data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/rollback/apply',
      method: 'post',
      data,
    })
  },
  scmInfoOaApplyApi(data = {}) {
    return request({
      url: '/oa/scm/info/information/apply',
      method: 'post',
      data,
    })
  },
})
